import { useFragment } from "@apollo/client";
import {
  UserMedspaConfigFragment,
  UserMedspaConfigFragmentDoc,
} from "@/graphql/fragments/userMedspaConfig.graphql.types";
import InitialsAvatar, { InitialsAvatarProps } from "./initialsAvatar";

export type UserMedspaInitialsAvatarProps = InitialsAvatarProps & {
  userMedspaId?: string;
};

function UserMedspaInitialsAvatar({
  userMedspaId,
  ...props
}: UserMedspaInitialsAvatarProps) {
  const { data } = useFragment<UserMedspaConfigFragment>({
    fragment: UserMedspaConfigFragmentDoc,
    fragmentName: "UserMedspaConfig",
    from: {
      __typename: "userMedspa",
      id: userMedspaId,
    },
  });

  return (
    <InitialsAvatar
      {...props}
      initials={{
        ...props.initials,
        color: data?.color ?? props.initials.color,
        initials: data?.initials ?? props.initials.initials,
      }}
    />
  );
}

export default UserMedspaInitialsAvatar;
